// const BASE_URL = "http://localhost:3000";

// const BASE_URL = "https://apicivilmantra.aimantra.info";
let BASE_URL = "https://cipl.aimantra.info";

// BASE_URL = "https://n00nmkv7-8001.inc1.devtunnels.ms";
// BASE_URL = "https://n00nmkv7-8002.inc1.devtunnels.ms";
// BASE_URL = "https://5rn0m63d-8000.inc1.devtunnels.ms";

const BASE_URL_PREBID = "https://cipl.aimantra.info";
let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
// const BASE_URL_PREBID = "https://lr2gx6jv-8001.inc1.devtunnels.ms";

// const BASE_URL_PREBID = "http://localhost:8000";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

const AUTH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
};

const AUTHH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "multipart/form-data",
  },
};

export { BASE_URL, BASE_URL_PREBID, AUTH, AUTHH, FRONTEND_URL, IMAGE_URL };
